import React, { Component, createRef } from 'react';
import * as moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import FilterButton from '../../Common/FilterButtons';
import qs from 'query-string';
import { withRouter } from 'react-router-dom';

const NOTIFICATION_SEQUENCE_TAB = 4;
class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _type: '',
            _loanId: '',
            _fromDate: null,
            _toDate: null
        };
    }

    dateRef = createRef();

    handleDateEvent = (_event, picker) => {
        this.setState({
            _fromDate: picker.startDate.format('YYYY-MM-DD'),
            _toDate: picker.endDate.format('YYYY-MM-DD')

        });
    }

    resetFilter = () => {
        const queryItem = qs.parse(window.location.search);
        queryItem.type = '';
        queryItem.loanId = '';
        queryItem.fromDate = '';
        queryItem.toDate = '';
        this.props.history.push({
            search: qs.stringify(queryItem)
        });
        this.setState({
            _type: '',
            _loanId: '',
            _fromDate: null,
            _toDate: null
        });
        this.dateRef.current.setStartDate(moment().toDate());
        this.dateRef.current.setEndDate(moment().toDate());
        this.props.onResetFilter();
    }

    handleSearch = () => {
        const {
            _type,
            _loanId,
            _fromDate,
            _toDate
        } = this.state;
        const queryItem = qs.parse(window.location.search);
        queryItem.type = _type;
        queryItem.loanId = _loanId;
        if (_fromDate) {
            queryItem.fromDate = _fromDate;
        }
        if (_toDate) {
            queryItem.toDate = _toDate;
        }
        if (Number(queryItem.tab) === NOTIFICATION_SEQUENCE_TAB) {
            this.props.history.push({
                search: qs.stringify(queryItem)
            });
        }
        this.props.onSearch({
            type: _type,
            loanId: _loanId.trim(),
            fromDate: _fromDate,
            toDate: _toDate
        });
    }

    retainStateFromQueryUrl = async () => {
        const queryItem = qs.parse(window.location.search);
        console.log('n-q', queryItem);
        const fromDate = !queryItem.fromDate ? moment().format('YYYY-MM-DD') : moment(queryItem.fromDate).format('YYYY-MM-DD');
        const toDate = !queryItem.toDate ? moment().format('YYYY-MM-DD') : moment(queryItem.toDate).format('YYYY-MM-DD');
        this.dateRef.current.setStartDate(moment(fromDate).toDate());
        this.dateRef.current.setEndDate(moment(toDate).toDate());
        await this.setState({
            _type: queryItem.type || '',
            _loanId: queryItem.loanId || '',
            _fromDate: queryItem.fromDate ? fromDate : null,
            _toDate: queryItem.toDate ? toDate : null
        });
        this.handleSearch();
    }

    componentDidMount() {
        this.retainStateFromQueryUrl();

    }

    componentDidUpdate(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            this.retainStateFromQueryUrl();
        }
    }

    render() {
        return (
            <div
                className="row"
                style={{ marginBottom: '30px', marginTop: '20px' }}
            >
                <div className="col-2">
                    <select
                        className="form-control"
                        onChange={(e) => { this.setState({ _type: e.target.value }); }}
                        value={this.state._type}
                    >
                        <option value="default">Type</option>
                        <option value="sms" >SMS</option>
                        <option value="email" >EMAIL</option>
                    </select>
                </div>
                <div className="col-3">
                    <input
                        className="form-control"
                        onChange={(e) => { this.setState({ _loanId: e.target.value }); }}
                        placeholder="Loan ID"
                        type="text"
                        value={this.state._loanId}
                    />
                </div>
                <div className="col-3">
                    <DateRangePicker
                        onEvent={this.handleDateEvent}
                        ref={this.dateRef}
                    >
                        <input
                            className="form-control"
                            type="text"
                        />
                    </DateRangePicker>
                </div>
                <FilterButton
                    handleSearch={this.handleSearch}
                    resetFilter={this.resetFilter}
                />
            </div>
        );
    }

}

export default withRouter(Filter);
